import * as React from "react"
import { format } from "date-fns"
import { nb } from "date-fns/locale"
import { CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

// Lokal "YYYY-MM-DD" <-> Date uten tidssone-skift (unngår at datoen hopper en
// dag pga. UTC).
const toYmd = (d: Date) => {
  const pad = (n: number) => String(n).padStart(2, "0")
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}
const parseYmd = (s: string) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s)
  if (!m) return undefined
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
}

// Gjennomgående datovelger (shadcn: knapp + popover + kalender). Verdi inn/ut er
// "YYYY-MM-DD" (tom streng = ingen dato).
export const DatePicker = ({
  value,
  onChange,
  placeholder,
  className,
  id,
  disabled,
}: {
  value?: string | null
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  id?: string
  disabled?: boolean
}) => {
  const [open, setOpen] = React.useState(false)
  const date = value ? parseYmd(value) : undefined

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          id={id}
          type="button"
          variant="outline"
          disabled={disabled}
          className={cn(
            "h-9 w-full justify-start text-left font-normal",
            !date && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date
            ? format(date, "d. MMMM yyyy", { locale: nb })
            : (placeholder ?? "Velg dato")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          defaultMonth={date}
          autoFocus
          onSelect={(d) => {
            onChange(d ? toYmd(d) : "")
            setOpen(false)
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
